import { render, staticRenderFns } from "./BirIsinYapilmasiVeyaYapilmamasiAlacakFormWizard.vue?vue&type=template&id=5a6f4b2e"
import script from "./BirIsinYapilmasiVeyaYapilmamasiAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./BirIsinYapilmasiVeyaYapilmamasiAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports